<ng-container class="section-header-container">
	<ion-item class="section-item">
		<ion-label class="ion-text-wrap">{{ title }}</ion-label>
		<ion-button class="close-icon-btn" slot="end" fill="clear" *ngIf="showRemoveIcon" (click)="onRemove.emit($event)">
			<ion-icon name="close-circle" slot="icon-only"></ion-icon>
		</ion-button>
	</ion-item>
	<ion-toolbar *ngIf = "showSectionScore && availableScore !=0" Class="section-score-display-new-line">
		<ion-label slot="start">{{'SHARED_TEXT.SCORING.SECTION_SCORE' |translate}}</ion-label>
		<ion-label *ngIf="!isDM" slot="end">{{currentScore}}/{{availableScore}}</ion-label>
		<ion-label *ngIf="!isDM" slot="end">{{((currentScore/availableScore)*100 | number: '1.0-0')}}%</ion-label>
		<span *ngIf="isDM" slot="secondary" class = "DM-offset">
			<ion-label >{{currentScore}}/{{availableScore}}</ion-label>
			<ion-label >{{((currentScore/availableScore)*100 | number: '1.0-0')}}%</ion-label>
		</span>
		<ion-label *ngIf="isDM" slot="primary" class = "DM-offset-body" />
		<ion-label *ngIf="isDM" slot="end" class = "DM-offset-body" />
	</ion-toolbar>


</ng-container>